const func = ($target) => {

    function custCenterMode() {
        var t = $(".large-slider-slider-flex-group").offset().left,
            i = $(".large-slider-container"),
            e = $(".large-slider-slider-flex-group").width();
        $(window).outerWidth() >= 1024
            ? (i.css("transform", "translate3d(" + (t - 25) + "px, 0px, 0px)"), $(".large-slider-item", i).css("width", "auto"))
            : $(window).outerWidth() <= 1023
            ? (i.css("transform", "translate3d(" + (t - 25) + "px, 0px, 0px)"), $(".large-slider-item", i).css("width", (e + 50)))
            : (i.css("transform", "translate3d(" + (t - 25) + "px, 0px, 0px)"), $(".large-slider-item", i).css("width", "auto")),
            $(window).outerWidth() < 835
                ? (i.css("transform", "translate3d(" + (t - 25) + "px, 0px, 0px)"), $(".large-slider-item", i).css("width", (e + 50)))
                : $(".large-slider-item-image", i).removeAttr("style");
    }

    function largeResSlider() {
        $('.large-slider-container').each(function (key, item) {

            var slider$LSName = 'slider' + key;
            var sliderNav$LSName = 'sliderNav' + key;

            this.id = slider$LSName;

            var slider$LS = '#' + slider$LSName;

            window.loader.key('slick', function () {
                var SlickS = jQuery(slider$LS).slick({
                    arrows: false,
                    infinite: false,
                    speed: 500,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    variableWidth: true,
                    asNavFor: '.large-slider-labels',
                });
                    var slick2 = jQuery('.large-slider-labels').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    asNavFor: '.large-slider-container',
                    dots: false,
                    centerMode: false,
                    focusOnSelect: true,
                    variableWidth: true,
                    prevArrow: '<a class="carousel-control-prev slick-arrow ' + sliderNav$LSName + '" href="#resourceSliderBtn" role="button" data-slide="prev" data-ga="Carousel - Previous" data-ga-category="Action" style="display: flex;"><svg width="40" height="40" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 43C33.8218 43 43 33.8218 43 22.5C43 11.1782 33.8218 2 22.5 2C11.1782 2 2 11.1782 2 22.5C2 33.8218 11.1782 43 22.5 43ZM45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 8.3447e-07 34.9264 8.3447e-07 22.5C8.3447e-07 10.0736 10.0736 8.3447e-07 22.5 8.3447e-07C34.9264 8.3447e-07 45 10.0736 45 22.5ZM23.2071 30.3929C23.5976 30.7834 23.5976 31.4166 23.2071 31.8071C22.8166 32.1976 22.1834 32.1976 21.7929 31.8071L13.1929 23.2071C12.8024 22.8166 12.8024 22.1834 13.1929 21.7929L21.7929 13.1929C22.1834 12.8024 22.8166 12.8024 23.2071 13.1929C23.5976 13.5834 23.5976 14.2166 23.2071 14.6071L16.3142 21.5H31.1C31.6523 21.5 32.1 21.9477 32.1 22.5C32.1 23.0523 31.6523 23.5 31.1 23.5H16.3142L23.2071 30.3929Z" fill="#C4C4C4"/></svg></a>',
                    nextArrow: '<a class="carousel-control-next slick-arrow ' + sliderNav$LSName + '" href="#resourceSliderBtn" role="button" data-slide="next" data-ga="Carousel - Next" data-ga-category="Action" style="display: flex;"><svg width="40" height="40" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 2C11.1782 2 2 11.1782 2 22.5C1.99999 33.8218 11.1782 43 22.5 43C33.8218 43 43 33.8218 43 22.5C43 11.1782 33.8218 2.00001 22.5 2ZM-3.93403e-06 22.5C-1.76132e-06 10.0736 10.0736 1.76132e-06 22.5 3.93403e-06C34.9264 6.10673e-06 45 10.0736 45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 -6.10673e-06 34.9264 -3.93403e-06 22.5ZM21.7929 14.6071C21.4024 14.2166 21.4024 13.5834 21.7929 13.1929C22.1834 12.8024 22.8166 12.8024 23.2071 13.1929L31.8071 21.7929C32.1976 22.1834 32.1976 22.8166 31.8071 23.2071L23.2071 31.8071C22.8166 32.1976 22.1834 32.1976 21.7929 31.8071C21.4024 31.4166 21.4024 30.7834 21.7929 30.3929L28.6858 23.5L13.9 23.5C13.3477 23.5 12.9 23.0523 12.9 22.5C12.9 21.9477 13.3477 21.5 13.9 21.5L28.6858 21.5L21.7929 14.6071Z" fill="#2892CC"/></svg></a>',
                    appendArrows: ".large-slider--arrow",
                    responsive: [
                        {
                            breakpoint: 836,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });
            });
        });
    }

    $(document).ready(function () {
        custCenterMode();
        largeResSlider();
    });
    $(window).resize(function () {
        custCenterMode()
    })

}
export default func;
